<template>
  <div>
    <RouterView v-if="isStandaloneRoute" />

    <div v-if="ressourcesLoaded && !isStandaloneRoute">
      <section-alert ref="alert"></section-alert>
      <div v-if="loggedIn">
        <div :class="loggedIn ? 'freshdesk' : ''" :loadFreshDesk="loadFreshDesk()">
          <v-app v-if="hubConnected && hubReady">
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />

            <drawer-navigation v-if="loggedIn && !isMobile && moduleList.length > 0"
                               :modules="moduleList"
                               :old-notifs="oldNotifs"
                               :user="user"
                               :inDashboard="inDashboard"
                               @hasMultipleProfile="hasMultipleProfile"
                               @home="home"
                               @goToProfil="goToProfil"
                               @goToPreference="goToPreference"
                               @goToFreshdesk="openFreshdesk"
                               @logout="logout">
            </drawer-navigation>

            <v-main :style="cssVars()" class="main-container">
              <v-container ref="CONTAINER" fluid :class="showNotificationPanel && !isMobile ? 'col pt-7'  : ''"
                           :style="!loggedIn ?
                       'padding: 0 !important; margin: 0 !important; max-width: 100%;'
                       :
                       ''">
                <div v-for="route in listRoutes" :key='route.id'>
                  <notif-sections :route="route"
                                  @close-dialog="removeRoute">
                  </notif-sections>
                </div>

                <bottom-nav v-if="loggedIn && isMobile" :navigation-items="navigationItems"></bottom-nav>

                <RouterView />

                <div v-if="scroll" style="position: absolute; z-index: 999; bottom: 20px; right: 35%;">
                  <div style="height:70px; width: 70px;">
                    <v-img src='@/assets/scroll-down.gif'></v-img>
                  </div>
                </div>
              </v-container>

            </v-main>
             <section-assistant></section-assistant>
             <dsn-reminder></dsn-reminder>
            <v-footer v-if="!isProduction">
              <v-row>
                <div class="footer">
                  Appli test <span style="font-size: 12px">
                    V{{ appVersion }}
                  </span>
                </div>
              </v-row>
            </v-footer>
          </v-app>
        </div>
      </div>
      <div v-else>
        <RouterView />
      </div>
    </div>
  </div>
</template>


<script lang="ts">
  import { storeContact, storeMail, storeNotif, storeSession, storeUser } from "@/generated/stores";
  import { type AxiosResponse } from 'axios';
  import NotificationBellWithCounter from '@/framework/notif/components/NotificationBellWithCounter.vue';
  import { Alerts } from "@/framework/base/helpers/Alerts";
  import HttpData from "@/generated/classes/HttpData";
  import UserProfile, { EnumProfile } from "@/framework/base/classes/UserProfile";
  import ListNotifications from '@/framework/notif/components/ListNotifications.vue';
  import { isMobile } from "@/style/StyleHelpers";
  import { NotifWatcher, RouteBuilder } from "@/generated/router/RouteBuilder";
  import Notif from "@/generated/classes/Notif";
  import Route from "@/generated/classes/Route";
  import { CiRouter, goToModule } from '@/framework/base/helpers/NavHelper';
  import { memeRoute, notifierFermeture } from '@/custom/helpers/attenteRoute';
  import Dialog from "@/generated/classes/Dialog";
  import { Dialogs } from '@/framework/base/helpers/Dialogs';
  import NotifSections, { loadAttrib } from "@/extend/sections/NotifSectionsExtend.vue";
  import { MapRessource, Ressources } from '@/framework/base/helpers/Ressources';
  import Ressource, { type RessourceUpdated } from '@/framework/ressource/classes/Ressource';
  import {
    AppRessources,
    FwkRessources,
  } from '@/ressources/globalRessources';
  import { ElementPosition, Position } from '@/framework/base/helpers/ElementPosition';
  import { setEditRessource as EditFieldSetEditRessource } from '@/framework/base/components/EditField.vue';
  import { setEditRessource as CheckFieldSetEditRessource } from "@/framework/base/components/CheckField.vue";
  import { setEditRessource as SelectFieldSetEditRessource } from "@/framework/base/components/SelectField.vue";
  import { setEditRessource as ModuleHeaderSetEditRessource } from '@/framework/base/components/ModuleHeader.vue';
  import { setEditRessource as SectionHeaderSetEditRessource } from '@/framework/base/components/SectionHeader.vue';
  import { Fiches, Modules, Sections } from '@/generated/classes/AppSchema';
  import { generatedRessources } from '@/generated/ressources/generatedRessources';
  import HubServices from "@/generated/hub/HubServices";
  import { setScrollFiche } from '@/framework/base/components/FicheBase';
  import DialogHubManager from "@/framework/dialog/helpers/DialogHubManager";
  import BottomNav from '@/framework/base/components/BottomNav.vue';
  import { NavigationItem } from "@/framework/base/classes/NavigationItem";
  import Module from "@/generated/classes/Module";
  import SectionAlert, { setOpenAlert } from '@/framework/base/components/SectionAlert.vue';
  import SectionAssistant from '@/custom/sections/SectionAssistant.vue';
  import DsnReminder from '@/custom/components/DsnReminder.vue';
  import MetaAttrib from "@/generated/classes/MetaAttrib";
  import ProfilSelector from "@/framework/connection/components/ProfilSelector.vue";
  import GraphData from "@/generated/classes/GraphData";
  import Contact from "@/generated/classes/Contact";
  import DrawerNavigation from "@/framework/base/components/DrawerNavigation.vue"
  import DefaultValue from "./defaultValue";
  import {defineComponent, nextTick} from "vue";
  import AvatarImage from './assets/avatar.png';
  import { isProduction } from '@/framework/base/helpers/Environment';
  import { useRoute, useRouter } from 'vue-router'
  import Sso from "@/generated/classes/Sso";
  import dashboard from "@/views/Dashboard.vue";
  import Pays from "@/generated/classes/Pays.ts";

  export default defineComponent({
    components: {
      NotificationBellWithCounter,
      ListNotifications,
      NotifSections,
      BottomNav,
      ProfilSelector,
      DrawerNavigation,
      SectionAlert,
      SectionAssistant,
      DsnReminder
    },
    data() {
      const navItems: NavigationItem[] = [];
      const navModules: Module[] = [];
      const oldNotifs: Notif[] = [];
      const ModuleDimensions: Position = new Position();
      const listRoutes: Route[] = [];
      const notifications: Notification[] = [];
      const appVersion = import.meta.env.VITE_APP_VERSION
      return {
        isProduction: isProduction(),
        isMobile: isMobile(),
        registered: false,
        logginOut: false,
        notifications,
        showLogin: false,
        showRegister: false,
        iconTicket: AvatarImage,
        listRoutes,
        showNotifSection: false,
        ressourcesLoaded: false,
        showNotificationPanel: false,
        showModeConnexionModal: false,
        transitionName: "",
        ModuleDimensions,
        scroll: false,
        oldNotifs,
        lastRoute: new Route(),
        navModules,
        navItems,
        hubConnected: false,
        router: useRouter(),
        route: useRoute(),
        appVersion,
        hubReady: false,
        freshdeskLoading: false,
        freshdeskLoaded: false,
        tabVisibleHandler: null as (() => void) | null,
        lastFocusRefreshAt: 0,
        versionConflictHandled: false,
        wasHidden: false,
        tabRefreshInProgress: false,
        pendingVersionConflict: false
      }
    },
    computed: {
      isStandaloneRoute(): boolean {
        return this.route.name === 'Signed' || this.route.name === 'PaymentStatus';
      },
      dashboard() {
        return dashboard
      },
      userCI98(): boolean {
        const user = storeSession.connectedUser;
        return (user != null && user.client98 > 0);
      },
      moduleList(): Module[] {
        this.getModules();
        return this.navModules
      },
      navigationItems(): NavigationItem[] {
        this.mobileItems(this.moduleList);
        return this.navItems;
      },
      showList(): boolean {
        return this.isMobile && storeSession.GetShowList;
      },
      showRegisterDialog: {
        get(): boolean {
          return this.showRegister || this.route.query.key == "subscribe" || this.route.name == "Onboarding";
        },
        set(value: boolean) {
          this.showRegister = value;
        }
      },
      showOnboardingDialog(): boolean {
        return this.route.name == "HomePage" && this.route.query.key == "onboarding";
      },
      showLoginDialog: {
        get(): boolean {
          return this.showLogin || this.route.query.key == "login";
        },
        set(value: boolean) {
          this.showLogin = value;
        }
      },
      loggedIn(): boolean {
        const user = storeSession.connectedUser;
        if (user != null && user.id > 0) {
          if (UserProfile.hasProfile(user, EnumProfile.superAdmin)) {
            this.initServerRessource();
          }
          this.register();
          this.checkHubReady();
          this.setLoggingOut(false);
          return true;
        } else {
          return false;
        }
      },
      hasMultipleProfile(): boolean {
        const user = storeSession.connectedUser;
        if (user != undefined) {
          return UserProfile.hasMultipleProfile(user)
        } else {
          return false;
        }
      },
      inDashboard(): boolean {
        console.log(this.route.name);
        return this.route.name == "Dashboard"
      },
      userName(): string {
        if (storeSession.sessionValid) {
          const user = storeSession.connectedUser;
          if (user != undefined) {
            this.register();
            const contact = storeContact.getContact(user.id);
            if (contact != undefined) {
              return contact.prenom + " " + contact.nom;
            } else {
              if (user.mailId) {
                const mail = storeMail.getMail(user.mailId);
                if (mail != undefined) {
                  return mail.adresse;
                }
              }
            }
          }
        }
        return "";
      },
      user(): Contact {
        let contact = new Contact();
        if (storeSession.sessionValid) {
          const user = storeSession.connectedUser;
          if (user != undefined) {
            this.register();
            contact = storeContact.getContact(user.id);
            if (contact != undefined) {
              return contact;
            }
          }
        }
        return contact;
      },
    },
    watch: {
      "$route": [{
        immediate: true, deep: true,
        handler: "onUrlChange"
      }]
    },
    async mounted() {
      await this.checkHubReady();
      document.addEventListener('visibilitychange', this.onTabVisibilityChange);
      window.addEventListener('focus', this.onWindowFocus);
    },

    beforeUnmount() {
      document.removeEventListener('visibilitychange', this.onTabVisibilityChange);
      window.removeEventListener('focus', this.onWindowFocus);
    },
    created() {
      //storeSession.clearData();
      if (storeSession.modeLocal) {
        //                store.dispatch('loadStoresData', this.$serverData)
      }
      storeSession.setLogoutMethod(this.logout);
      // Cette fonction pour vérifier si la session n'est pas expirée et si on actualise la page on garde la session
      const userString = localStorage.getItem("user"); // Récupérer les données utilisateur du stockage local
      if (userString) {
        // vérifier s'il y a bien un utilisateur
        const userData = JSON.parse(userString); // Analyser les données utilisateur dans JSON
        if (userData.user) {
          userData.user.firstConnexion = false;
        }
        storeSession.setUserData(userData);
      }
      if (storeSession.httpCx != null) {



        storeSession.httpCx.interceptors.response.use(
          (response: any) => {
            this.hubConnected = true
            if (response.status == 200) {
              return response
            } else if (response.status == 202) {
              this.manageNotifs(response);
              response.status = 200;
              response.data = response.data.obj;
              if (response.data) {
                response.data.failed = true;
              }
              return response;
            }
          }, // renvoie la réponse
          (err) => {
            if (err.message !== "Network Error") {
              if (err.response.status != 200) {
                if (err.response.status == 401) {
                  if (!this.showRegisterDialog && !this.showOnboardingDialog) {
                    this.logout();
                  }
                } else if (err.response.status == 500) {
                  const errorDetail = err.response.data.detail;
                  Alerts.debug(errorDetail);
                  err.response.data = "Internal Server Error";
                  return err.response;
                } else if (err.response.status == 409) {
                  if (!this.ressourcesLoaded) {
                    this.pendingVersionConflict = true;
                    return err.response;
                  }
                  this.showVersionConflictDialog();
                  return err.response;
                } else {
                  const error = err.response.data;
                  Alerts.debug(error);
                  return err.response;
                }
              }
            } else {
              console.log("Network error");
              return null;
            }
          }
        );
        this.initResources(this.isMobile);
        loadAttrib();
        storeUser.registerUser();
        DefaultValue.initialise();
      }
    },
    methods: {
      async checkHubReady(): Promise<void> {
        const maxRetries = 10;
        let attempts = 0;
        while (attempts < maxRetries) {
          if (HubServices.hubReady()) {
            try {
              await HubServices.connection.invoke('EnterDocument', storeSession.httpToken);
              this.hubReady = true;
            } catch (err) {
              console.log('Hub failed due to hub ready', err);
            }
            return;
          }
          await new Promise(resolve => setTimeout(resolve, 500));
          attempts++;
        }
      },
      showVersionConflictDialog(): void {
        if (this.versionConflictHandled || !this.ressourcesLoaded) {
          return;
        }
        this.versionConflictHandled = true;
        const dialog = new Dialog();
        dialog.label = "Une nouvelle version est disponible. L'application va être rechargée.";
        Alerts.message(dialog).then((res) => {
          if (res) {
            setTimeout(() => window.location.reload(), 500);
          }
        });
      },
      async refreshOnTabFocus(): Promise<void> {
        if (document.visibilityState !== 'visible') {
          return;
        }
        if (!this.wasHidden) {
          return;
        }
        if (this.tabRefreshInProgress) {
          return;
        }
        if (this.versionConflictHandled) {
          return;
        }
        this.wasHidden = false;
        this.tabRefreshInProgress = true;
        try {
          await Pays.getByCode('FR');
        } finally {
          this.lastFocusRefreshAt = Date.now();
          this.tabRefreshInProgress = false;
        }
      },

      onTabVisibilityChange(): void {
        if (document.visibilityState === 'hidden') {
          this.wasHidden = true;
          return;
        }

        this.refreshOnTabFocus();
      },

      onWindowFocus(): void {
        this.refreshOnTabFocus();
      },

      setLoggingOut(value: boolean) {
        this.logginOut = value;
      },
      enableScroll(): void {
        this.scroll = true;
        setTimeout(() => {
          this.scroll = false
        }, 3000);
      },
      initResources(isMobile: boolean) {
        Ressources.download(isMobile).then(async () => {
          Ressources.define(AppRessources);
          Ressources.define(FwkRessources);
          Ressources.define(generatedRessources, false);
          Dialogs.setAdminEditDialog(this.adminEditDialog);
          Alerts.setEditDialog(Dialogs.editDialog);
          CiRouter.setAddRoute(this.addRoute);
          if (!isMobile) {
            Ressources.setAdminEditRessource(this.adminEditRessource);
            EditFieldSetEditRessource(Ressources.editRessource);
            CheckFieldSetEditRessource(Ressources.editRessource);
            SelectFieldSetEditRessource(Ressources.editRessource);
            ModuleHeaderSetEditRessource(Ressources.editRessource);
            SectionHeaderSetEditRessource(Ressources.editRessource);
          }
          setScrollFiche(this.enableScroll);
          if (!this.isStandaloneRoute) {
            setOpenAlert((dialog: Dialog) => this.showAlert(dialog));
          }
          this.ressourcesLoaded = true;
          await nextTick();

          if (this.pendingVersionConflict && !this.versionConflictHandled) {
            this.pendingVersionConflict = false;
            this.showVersionConflictDialog();
          }
        }).catch((err) => {
          console.error('Failed to initialize resources', err);
        });
      },
      showAlert(dialog: Dialog): Promise<string> {
        return new Promise((resolve) => {
          // @ts-expect-error : generated method
          this.$refs.alert.openModal(dialog).then((res) => {
            resolve(res);
          });
        })
      },
      initServerRessource() {
        Ressources.initServer(AppRessources);
        Ressources.initServer(FwkRessources);
        Ressources.initServer(generatedRessources);
      },
      goToPreference() {
        const route = new Route();
        route.module = Modules.PREFERENCE;
        route.fiche = Fiches.PREFERENCE;
        if (storeSession.connectedUser) {
          route.ficheObjId = storeSession.connectedUser.id;
        }
        goToModule(this.router, route);
      },
      goToProfil() {
        const user = storeSession.connectedUser;
        if (user) {
          const route = new Route();
          if ((user.currentProfil & EnumProfile.salarie) > 0) {
            route.module = Modules.SALARIE;
            route.fiche = Fiches.SALARIE_ABSTRACT;
          } else {
            route.module = Modules.PROFIL;
            route.fiche = Fiches.PROFIL;
          }
          if (storeSession.connectedUser) {
            route.ficheObjId = storeSession.connectedUser.id;
          }
          goToModule(this.router, route);
        }
      },
      sameRoute(n1: Route, n2: Route): boolean {
        return memeRoute(n1, n2);
      },
      showRoute(route: Route) {
        if (route != this.lastRoute) {
          this.lastRoute = route;
          const exists = this.listRoutes.some(r => this.sameRoute(r, route));
          if (!exists) {
            const lastIndex = this.listRoutes.length > 0 ? this.listRoutes[this.listRoutes.length - 1].id : 0;
            route.id = lastIndex + 1;
            this.listRoutes.push(route);
          }
        }
      },
      adminEditRessource(ressource: MapRessource, ressourceUpdated: RessourceUpdated): boolean {
        const user = storeSession.connectedUser;
        if (user && UserProfile.canEditResources(user)) {
          const route = new Route;
          route.module = Modules.NONE;
          route.fiche = Fiches.NONE;
          route.section = Sections.ADMIN_RESOURCE;
          route.sectionObjId = ressource.id;
          route.attribut = ressourceUpdated;
          this.showRoute(route);
          return true;
        } else {
          return false;
        }
      },
      adminEditDialog(dialog: Dialog): boolean {
        const user = storeSession.connectedUser;
        if (user && UserProfile.canEditResources(user)) {
          const route = new Route;
          route.module = Modules.NONE;
          route.fiche = Fiches.NONE;
          route.section = Sections.ADMIN_DIALOG;
          route.sectionObjId = dialog.id;
          this.showRoute(route);
          return true;
        } else {
          return false;
        }
      },
      addRoute(route: Route) {
        let found = false;
        let routeId = 0
        this.listRoutes.forEach((n) => {
          if (this.sameRoute(n, route)) {
            found = true;
          }
          if (n.id >= routeId) {
            routeId = n.id + 1;
          }
        });
        if (!found) {
          route.id = routeId;
          this.listRoutes.push(route);
        }
      },
      removeRoute(route: Route) {
        let index = -1;
        this.listRoutes.forEach((r) => {
          if (this.sameRoute(r, route)) {
            index = this.listRoutes.indexOf(r);
          }
        })
        if (index > -1) {
          this.listRoutes.splice(index, 1);
        }
        // Reprend les traitements client qui attendaient cette fermeture (actions de masse).
        notifierFermeture(route);
      },
      manageNotifs(response: AxiosResponse): void {
        const httpData: HttpData = response.data;
        if (httpData.route != null) {
          if (!RouteBuilder.sameRoute(httpData.route)) {
            if (httpData.dialog) {
              Alerts.message(httpData.dialog).then((res) => {
                if (res) {
                  this.addRoute(httpData.route);
                }
              });
            } else {
              this.addRoute(httpData.route);
            }
          } else {
            const nw: NotifWatcher = new NotifWatcher();
            const fct: (value: Route, dialog: Dialog) => void = nw.getWatcher();
            fct(httpData.route, httpData.dialog);
          }
        } else if (httpData.dialog) {
          Alerts.message(httpData.dialog);
        }
      },
      cssVars() {
        const notifPanelDimensions = ElementPosition.getPosition(this.$refs['NOTIF_PANEL']);
        const containerDimensions = ElementPosition.getPosition(this.$refs['CONTAINER']);
        return {
          '--ModuleTop': this.ModuleDimensions.top + 'px',
          '--ModuleLeft': this.ModuleDimensions.left + 'px',
          '--ModuleHeight': this.ModuleDimensions.height + 'px',
          '--ModuleWidth': this.ModuleDimensions.width + 'px',
          '--containerWidth': containerDimensions?.width + 'px',
          '--containerLeft': containerDimensions?.left + 'px',
          '--containerTop': containerDimensions?.top + 'px',
          '--notifPanelWidth': notifPanelDimensions?.width + 'px'
        }
      },
      getModules(): Module[] {
        Module.list(this.isMobile).then((res: Module[]) => {
          if (this.navModules.length != res.length) {
            this.navModules = res;
          }
        });
        return this.navModules;
      },
      mobileItems(modules: Module[]): void {
        const items: NavigationItem[] = []
        const navItem = new NavigationItem();
        const route = new Route();
        route.module = Modules.NOTIFICATION;
        navItem.module = Modules.NOTIFICATION;
        navItem.route = route
        navItem.picto = 'NotificationPicto';
        navItem.order = 1;
        items.push(navItem)
        modules.forEach((module) => {
          const navItem = new NavigationItem()
          navItem.module = module.route.module;
          navItem.route = module.route;
          navItem.picto = module.treeItem.treeIcon;
          navItem.order = module.ordreMobile;
          navItem.title = module.treeItem.name;
          items.push(navItem)
        });
        items.sort((a, b) => a.order - b.order);
        this.navItems = items;
      },
      register(): void {
        if (
          !this.registered && HubServices.hubReady()) {
          storeNotif.registerNotif();
          HubServices.onRouteShowRoute(this.showRoute);
          DialogHubManager.waitQuestion(this.showDialog);
          HubServices.onMetaAttribDefine(this.defineMeta);
          HubServices.onGraphDataAdditional(this.showGraphData);
          this.SetFresdeskInfo(this.userName, this.user?.mail);
          this.oldNotifs = [];
          this.registered = true;
        } else if (!this.registered) {
          setTimeout(() => this.register(), 1000);
        }
      },
      ressourceUpdated(obj: Ressource): void {
        Ressources.set(obj);
      },
      notifDeleted(id: number): void {
        const index = this.notifications.findIndex((x) => x.tag == id.toString());
        if (index >= 0) {
          this.notifications.splice(index, 1);
        }
      },
      showGraphData(graphData: GraphData) {
        const route = new Route;
        route.module = Modules.NONE;
        route.fiche = Fiches.NONE;
        route.section = Sections.GRAPH_DIALOG;
        route.attribut = graphData;
        this.showRoute(route);
      },
      showDialog(dialog: Dialog) {
        const route = new Route;
        route.module = Modules.NONE;
        route.fiche = Fiches.NONE;
        route.section = Sections.DIALOG;
        route.attribut = dialog;
        this.showRoute(route);
      },
      defineMeta(metaAttrib: MetaAttrib) {
        const route = new Route;
        route.module = Modules.NONE;
        route.fiche = Fiches.NONE;
        route.section = Sections.DEFINE_META_ATTRIB;
        route.attribut = metaAttrib;
        this.showRoute(route);
      },
      setMeta(metaAttribs: MetaAttrib[]) {
        const route = new Route;
        route.module = Modules.NONE;
        route.fiche = Fiches.NONE;
        route.section = Sections.DIALOG;
        route.attribut = metaAttribs;
        this.showRoute(route);
      },
      home(): void {
        if (this.route.name != "Dashboard") {
          this.router.push({ name: "Dashboard" });
        }
      },
      logout(): void {
        if (!this.logginOut) {
          this.logginOut = true;
          if (storeSession.modeLocal) {
            storeSession.clearData();
            if (this.route.name != "HomePage") {
              this.router.push({ name: "HomePage" });
            }
            this.registered = false;
          } else {
            if (storeSession.logout !== undefined) {
              storeSession.logout().then((res) => {
                if (res) {
                  this.router.push({ name: 'Dashboard' });
                  setTimeout(() => window.location.reload(), 1000)
                } else {
                  this.router.push({ name: "HomePage" });
                  this.registered = false;
                  this.logginOut = false;
                }
              });
            }
          }
        }
      },
      showNotificationMobile(): boolean {
        if (this.isMobile) {
          return this.isMobile && this.showNotificationPanel;
        } else {
          return this.isMobile;
        }
      },
      onUrlChange(destination: any, source: any) {
        if (source && source.name && source.name == "HomePage") {
          return;
        }
        this.transitionName = destination.meta.transition;
        if (destination.params.coordinates) {
          this.ModuleDimensions = destination.params.coordinates;
        }
      },
      loadFreshDesk(): void {
        if (!this.freshdeskLoaded && !this.freshdeskLoading) {
          this.freshdeskLoading = true;
          // @ts-expect-error : generated method
          window.fwSettings = { widget_id: 77000004453, locale: 'fr' };

          // @ts-expect-error : generated method
          !function () {
            if ("function" != typeof window.FreshworksWidget) {
              const n = function () {
                // eslint-disable-next-line prefer-rest-params
                n.q.push(arguments)
              };
              // @ts-expect-error : generated method
              n.q = [],
                // @ts-expect-error : generated method
                window.FreshworksWidget = n
            }
          }()

          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = 'https://euc-widget.freshworks.com/widgets/77000004453.js';
          script.onload = () => {
            setTimeout(() => {
              let name = 'not connected';
              let mail = 'not-connected@cheque-intermittents.com'
              if (this.user && this.user.id > 0) {
                const contact = storeContact.getContact(this.user.id);
                if (contact != undefined && contact.id > 0) {
                  name = contact.prenom + ' ' + contact.nom;
                  mail = contact.mail;
                }
                window.FreshworksWidget('identify', 'ticketForm', {
                  name: name,
                  email: mail
                });
              }
            }, 2500);
          }
          setTimeout(() => {
            document.head.appendChild(script)
            this.freshdeskLoaded = true;
          }, 2500);
        }
      },
      SetFresdeskInfo(name: string, email: string): void {
        if (this.freshdeskLoaded) {
          window.FreshworksWidget('identify', 'ticketForm', {
            name: name,
            email: email
          });
        }
      },
      openFreshdesk(): void {
        Sso.redirection().then((url: string) => {
          window.open(url);
        });
      }
    }
  })

</script>

<style scoped>
  @font-face {
    font-family: "Inter";
    src: url('./assets/fonts/Inter-VariableFont_opsz,wght.ttf');
  }
</style>
<style>
  /* Positionne le dialogue Freshdesk */
  div#freshworks-container,
  div[id*="freshworks"],
  div[class*="freshworks"] {
    right: auto !important;
    left: 150px !important;
    bottom: 20px !important;
  }

  /* Positionne le widget Freshdesk */
  iframe[style*="position: fixed"][style*="bottom"][style*="right"] {
    right: auto !important;
    left: -10px !important;
    bottom: 20px !important;
  }
</style>

